import React, { useContext, useEffect, useState } from "react";
import Footer from './Footer'
import Heather from './Heather'
import MainCenter from './MainCenter'
export default function Main() {
    useEffect(() => {
    }, []);


    return (
        <>
            <Heather />
            <MainCenter/>
            {/*<Footer />*/}
        </>

    );

}
